import { DestroyRef, DOCUMENT, inject } from '@angular/core';

/**
 * Custom property on the document root that carries the height of the app shell's pinned top bar.
 *
 * Whatever else pins to the top of the viewport reads it to stay below the bar: the detail
 * toolbar and the section rail (`top`), and `html { scroll-padding-top }` so `scrollIntoView`
 * targets land clear of it. It is published only while a shell with a pinned bar is mounted —
 * the modern shell (menu above) and the classy shell (menu left), #22899 asks for both; every
 * consumer falls back to `0px`, which is what the other shells and Storybook need.
 */
export const STICKY_HEADER_OFFSET_PROPERTY = '--dd-sticky-header-offset';

/** The bar's height: Tailwind `h-16` on the header in both shell templates. One number, three places. */
export const STICKY_HEADER_OFFSET = '4rem';

/**
 * Publishes the pinned bar's height for the lifetime of the calling shell, and takes it away again
 * on destroy: a different shell then pins nothing and the consumers fall back to 0px.
 *
 * Call from the shell's constructor (or any injection context): it reads `DOCUMENT` and hooks the
 * component's `DestroyRef`.
 */
export function publishStickyHeaderOffset(): void {
  const root = inject(DOCUMENT).documentElement;
  root.style.setProperty(STICKY_HEADER_OFFSET_PROPERTY, STICKY_HEADER_OFFSET);
  inject(DestroyRef).onDestroy(() => root.style.removeProperty(STICKY_HEADER_OFFSET_PROPERTY));
}
